<div ngbDropdown class="d-inline-block d-inline-block-actions width-100">
  <button
    role="button"
    type="button"
    [attr.aria-label]="userData.isStaff ? 'Staff Actions' : 'Other Actions'"
    class="btn btn-outline-primary width-100"
    [attr.id]="userData.systemCategory === systemCatagory.VERSO ? 'ilsdesk' : 'illdesk'"
    ngbDropdownToggle
    style="max-width: 206px"
  >
    {{ userData.isStaff ? 'Staff' : 'Other' }} Actions
  </button>
  <div
    ngbDropdownMenu
    [attr.aria-labelledby]="
      userData.systemCategory === systemCatagory.VERSO ? 'ilsdesk' : 'illdesk'
    "
    style="max-width: 206px"
  >
    @for (item of actionItems; track item) {
      <button
        role="button"
        type="button"
        [attr.aria-label]="item.label"
        class="dropdown-item"
        (click)="handleFullRecordAction(item.action)"
      >
        {{ item.label }}
      </button>
    }
  </div>
</div>
